import React, { useEffect, useState } from 'react'
import './SingleTravel.min.css'
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import axios from 'axios';
import { Travel } from '../TravelsPlanned/model'
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Note {
  id: number;
  name: string;
  isDone: number;
}

interface Props {
  notes: Note[];
  setNotes: React.Dispatch<React.SetStateAction<Note[]>>;
  note: Note;
  travel: Travel;
}


const NotesTravel: React.FC<Props> = ({ notes, setNotes, note, travel }) => {
  const [edit, setEdit] = useState<boolean>(false);
  const [editNote, setEditNote] = useState<string>(note.name);
  const [addOption, setAddOption] = useState<boolean>(false);



  const handleChange = (id: number, isDone: number, city: string) => {
    if (isDone === 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    axios.post(ipAddress + '/doneNoteTravel', {
      id: id,

      isDone: isDone,
    })

    // setBaggages(baggages.map((baggage) => baggage.id == id ? {...baggage, isDone: 0}: baggage ))

  };





  const handleDelete = (id: number, name: string) => {
    Swal.fire({
      title: name,
      text: "Czy jesteś pewien, że chcesz usunąc ten element ?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteNoteTravel', {
          id: id,
        })
        // setCosts(costs.filter((cost) => (cost.id !== id) ))
      }
    })

  }

  

  const handleEdit = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    setAddOption(false)
    axios.post(ipAddress + "/editNote", {
      note: editNote,
      id: id,

    })
      .then((response) => {
        /*  setTravels(travels.map((travel) => (
           travel.id === id ? {...travel, city:editCity , date: editDate } : travel
         ))) */
      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditNote(note.name);
  }

  const resize = () => {
    let element = document.getElementById("textAreaEditNote")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }




  return (

    <div className='list'>

     <div className='done'>

        {note.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true}
              onChange={() => handleChange(note.id, note.isDone, travel.city)}
            ></input>
            <s className='text'> {note.name} </s>

          </span>

        ) : (
          <span>
            <input type='checkbox' checked={false}
              onChange={() => handleChange(note.id, note.isDone, travel.city)}
            ></input>
             <div className='icons'>
              <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
              <span className='delete' onClick={() => handleDelete(note.id, note.name)} ><AiFillDelete /></span>
              </div>
            <span className='text'>{note.name}</span>




          </span>
        )
        }

     </div>

      {edit ? (
        <form className='editNote' onSubmit={(e) => { handleEdit(e, note.id) }}>
          <button type='button' id='close' onClick={() => close()} >X</button>
          <p>Edytuj notatke</p>
          <div className='thing'>
            <label htmlFor="thing">Co: </label>
            <textarea id='textAreaEditNote'
              rows={4}

              value={editNote}
              onChange={(e) => (resize(), setEditNote(e.target.value))}
              onClick={() => resize()}
            ></textarea>
          </div>

          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }

    </div>



  )
}

export default NotesTravel